import { RoutineConfig } from '../routineConfig';
import { WorkflowPageConfig } from './workflowPageConfig';

export interface WorkflowRoutineConfig extends RoutineConfig {
  pages: WorkflowPageConfig[];
  idpEnabled?: boolean;
  /**
   * Optional admin-written description of the document this routine's operators
   * photograph ("dot-matrix ADM grain scale ticket; weights in lbs"). Primes the
   * extraction model with what it is looking at, ahead of the per-field
   * `idpPrompt`s. Never shown to operators; blank means "no descriptor" and the
   * job is built exactly as it was before this field existed.
   */
  idpDocumentDescription?: string;
}
